import {mapState} from "vuex";

export default {
    data() {
        return {
            model: null,
            single: {},
            header: [],
            fields: {},
            edit_mode: false,
            view_mode: false,
            page: {
                total: 0,
                display: 1,
                current: 0,
                count: 0,
                size: 20
            },
            search: {
                search: '',
                filters: [],
                page: 1,
                sort: {},
                date_rage: [],
                old: null,
                extra_filters:{
                    expire:'未过期'
                }
            },
            records: [],
            is_first: true,
        }
    },
    computed: {
        ...mapState(['user', 'preset', 'process']),
        canAdd() {
            let can = true;
            const level = parseInt(this.user.role_level);
            if (this.preset.app.create_meeting_forbidden) {
                if (level < 3) {
                    can = false;
                }
            }
            return can;
        },
        can_copy() {
            return this.$route.meta ? this.$route.meta.copy : false;
        },
        can_add() {
            return this.$route.meta ? !this.$route.meta.no_add : true
        },
        can_delete() {
            return this.$route.meta ? !this.$route.meta.no_delete : true
        },
        can_edit() {
            return this.$route.meta ? !this.$route.meta.no_edit : true
        }

    },
    methods: {

        reload() {
            let vm = this;
            if (this.old !== this.search.search) {
                this.search.page = 1;
                this.old = this.search.search;
            }
            this.$api(this.model + '.List', this.search, true).then(response => {
                if (response.data.data) {
                    if (vm.is_first)
                        vm.header = response.data.data.header;
                    vm.records = response.data.data.data;
                    vm.page = Object.assign(vm.page, response.data.data.page);
                    vm.is_first = true;
                }
            });
        },
        handleSuccess() {
            this.edit_mode = false;
            this.reload();
        },
        handleCancel() {
            this.edit_mode = false;
        },
        handleEdit(id) {
            let vm = this;
            this.$api(vm.model + '.Get', {id: id}, true).then(response => {
                vm.single = response.data.data.data || {};
                vm.fields = response.data.data.fields;
                vm.edit_mode = true;
                Object.keys(vm.fields).forEach(function (key) {
                    let x = vm.fields[key];
                    if (x.type === 'picture' && !vm.single[key]) {
                        vm.single[key] = [];
                    }
                });
            });
        },
        handleCopy(id) {
            let vm = this;
            this.$api(vm.model + '.Get', {id: id}, true).then(response => {
                vm.single = response.data.data.data || {};
                vm.single.copy_id = vm.single.id;
                vm.single.id = 0;
                vm.fields = response.data.data.fields;
                vm.edit_mode = true;
                vm.fields.forEach(x => {
                    if (x.type === 'picture' && !vm.single[x]) {
                        vm.single[x] = []
                    }
                });
            });
        },
        handleReload(data) {
            this.search = data;
            this.reload();
        },
        handleReview(id) {
            let vm = this;
            this.$api(this.model + '.Get', {id: id, review: true}, true).then(res => {
                vm.single = res.data.data;
                this.view_mode = true;
            });
        }
    },
    mounted() {
        this.reload();
    },
}
